import React from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';

import 'react-day-picker/lib/style.css';
import './ts-picker.css';

/**
 * Controlled component to pick a date
 */
const DatePicker = ({ value, onChange, noun }) => (
  <div className="timestamp-picker">
    <DayPickerInput
      value={value}
      placeholder={`${noun} since...`}
      dayPickerProps={{
        selectedDays: [value],
        disabledDays: { after: new Date() },
        numberOfMonths: 2,
        todayButton: `Today's ${noun}`,
      }}
      onDayChange={(day) => {
        if (day != null) day.setHours(0);
        onChange(day);
      }}
      clickUnselectsDay
    />
  </div>
);

DatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(Date),
  noun: PropTypes.string.isRequired,
};

DatePicker.defaultProps = {
  value: null,
};

export default DatePicker;
